import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../../components/Modal/ModalContext';
import { TableContext } from '../../../components/Table/TableContext';
import { AssignVehicleDataType } from '../../../models/dashboard/driver-list/assign-vehicle';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useAssignDriver = () => {
  const modalContext = useContext(ModalContext);
  const request = useHttps();
  const tableContext = useContext(TableContext);
  const [loading, setLoading] = useState(false);

  const onAssignDriverError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while assigning driver.',
    );
  };

  const onAssignDriverSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success('Driver assigned successfully.');
    tableContext?.setRefreshTable(!tableContext.refreshTable);
    modalContext?.setShowModal(false);
  };

  const assignDriver = (data: AssignVehicleDataType) => {
    const url: HttpConfig = {
      url: 'api/v1/fleets/assign',
      method: 'post',
      data: data,
    };
    request(url, onAssignDriverSuccess, setLoading, onAssignDriverError);
  };

  return { assignDriver, loading };
};

export default useAssignDriver;
